import { z } from 'zod/v4';

import { CurrencyRuntype } from '../currency';

export interface MonetaryValueBackend extends z.infer<typeof MonetaryValueBackendRuntype> {}

export const MonetaryValueBackendRuntype = z.object({
    amount: z.string(),
    currency: CurrencyRuntype,
});

export interface ExchangedMonetaryValueBackend extends z.infer<typeof ExchangedMonetaryValueBackendRuntype> {}

export const ExchangedMonetaryValueBackendRuntype = z.object({
    converted_mv: MonetaryValueBackendRuntype,
    original_mv: MonetaryValueBackendRuntype,
});

export const ExchangedMonetaryValueBackendConvertedMVOnlyRuntype = ExchangedMonetaryValueBackendRuntype.omit({
    original_mv: true,
});

export const ExchangedMonetaryValueBackendOriginalMVOnlyRuntype = ExchangedMonetaryValueBackendRuntype.omit({
    converted_mv: true,
});

export type ExchangedMonetaryValueBackendConvertedMVOnlyDTO = z.infer<
    typeof ExchangedMonetaryValueBackendConvertedMVOnlyRuntype
>;
